module.exports = __webpack_public_path__ + "img/fragment_popup-center-bg.6895d30b.png";